import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconNonFillUser: FC<IconProps> = ({ $size, ...rest }) => (
  <IconNonFilledStyled {...{ $size, ...rest }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="white" />
      <path
        d="M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M3.875 27C5.10367 24.8714 6.87104 23.1038 8.99944 21.8748C11.1278 20.6459 13.5423 19.9989 16 19.9989C18.4577 19.9989 20.8722 20.6459 23.0006 21.8748C25.129 23.1038 26.8963 24.8714 28.125 27"
        stroke={colors[rest?.$color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </IconNonFilledStyled>
);

IconNonFillUser.defaultProps = iconDefaultProps;
IconNonFillUser.displayName = 'IconNonFillUser';

export default IconNonFillUser;
